import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PricePlanDialogService} from "../../services/price-plan-dialog-service.service";

export class ProgramServiceAreasBySpotTableRowCtrl implements IController {

  area: any;
  zone: any;
  serviceAreasOptionIds: string[];
  excludeServiceAreasIds: string[];
  onUpdateZone: Function;
  onDelete: Function;

  public isDesktop: boolean;
  private quantitySettingsOptions: any;
  public quantitySettingsValue: any;

  /* @ngInject */
  constructor(private pricePlanDialogService: PricePlanDialogService, private $mdMedia) {
    this.isDesktop = $mdMedia('gt-md');
  }

  $onInit() {
    this.quantitySettingsOptions = ['DEFAULT', 'CUSTOM', 'PARENT'];
    this._setQuantitySettingsValue();
  }

  $onChanges(changes) {
    if (changes.area && !changes.area.isFirstChange() ||
        changes.zone && !changes.zone.isFirstChange()) {
      this._setQuantitySettingsValue();
    }
  }

  onZoneChange(zone) {
    this.zone = zone;
    this.updateRequired();
  }

  onServiceAreaSelect(serviceArea) {

    if (!serviceArea) {
      return;
    }

    this.zone.toId = _.get(serviceArea, 'id');
    this.zone.name = _.get(serviceArea, 'areaName');
    this.updateRequired();
  }

  onSpotPriceChange() {
    this._setQuantitySettingsValue();
    this.updateRequired();
  }

  onQuantitySettingsChange(value) {
    const updatedZone = angular.copy(this.zone);

    if (!updatedZone.spotsQuantityPricing) {
      updatedZone.spotsQuantityPricing = {};
    }

    if (value === 'PARENT') {
      updatedZone.spotsQuantityPricing.spotsQuantityPricingUseDefault = false;
      updatedZone.spotsQuantityPricing.spotsQuantityPricingUseParent = true;
    } else if (value === 'DEFAULT') {
      updatedZone.spotsQuantityPricing.spotsQuantityPricingUseDefault = true;
      updatedZone.spotsQuantityPricing.spotsQuantityPricingUseParent = false;
    } else {
      updatedZone.spotsQuantityPricing.spotsQuantityPricingUseDefault = false;
      updatedZone.spotsQuantityPricing.spotsQuantityPricingUseParent = false;
    }

    this.zone = updatedZone;
    this.updateRequired();
  }

  onEditCustom($event) {
    const quantityDiscountLines = _.get(this.zone, 'spotsQuantityPricing.quantityDiscountLines', []);
    this.pricePlanDialogService.editPricePlanQuantityDiscountLines($event, quantityDiscountLines)
      .then((updatedQuantityDiscountLines) => {

        const updatedZone = angular.copy(this.zone);

        if (!updatedZone.spotsQuantityPricing) {
          updatedZone.spotsQuantityPricing = {};
        }

        if (!updatedZone.spotsQuantityPricing.quantityDiscountLines) {
          updatedZone.spotsQuantityPricing.quantityDiscountLines = [];
        }

        updatedZone.spotsQuantityPricing.quantityDiscountLines = updatedQuantityDiscountLines;
        updatedZone.spotsQuantityPricing.spotsQuantityPricingUseDefault = false;
        updatedZone.spotsQuantityPricing.spotsQuantityPricingUseParent = false;

        this.zone = updatedZone;
        this.updateRequired();
      })
  }

  private _setQuantitySettingsValue() {
    if (_.get(this.zone, 'spotsQuantityPricing.spotsQuantityPricingUseParent', false)) {
      this.quantitySettingsValue = 'PARENT';
    } else if (_.get(this.zone, 'spotsQuantityPricing.spotsQuantityPricingUseDefault', false)) {
      this.quantitySettingsValue = 'DEFAULT';
    } else {
      this.quantitySettingsValue = 'CUSTOM';
    }
  }

  private updateRequired() {
    this.onUpdateZone({zone: this.zone, areaId: this.area.id});
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programServiceAreasBySpotTableRow', {
    bindings: {
      zone: '<',
      area: '<',
      serviceAreasOptionIds: '<?',
      excludeServiceAreasIds: '<?',
      onUpdateZone: '&',
      onDelete: '&'
    },
    template: require('./program-service-areas-by-spot-table-row.html').default,
    controller: ProgramServiceAreasBySpotTableRowCtrl
  });
